<div class="engine-oil-dialoge">
  <div class="engine-oil-header">
    <div class="oil-header-left">
      <div class="oil-left-icon">
        <img src="../../../../assets/img/engine-oil-icon.png" alt="" />
      </div>
      <div class="oil-left-content">Select Engine Oil</div>
    </div>
    <div class="header-right">
      <div class="oil-right-icon">
        <i class="fal fa-times" (click)="handleClose()"></i>
      </div>
    </div>
  </div>
  <div class="engine-oil-body">
    <div class="row engine-oil-wrapper m-0">
      <div class="col-3 engine-oil-left">
        <div class="engine-oil-card-wrapper">
          <div class="oil-card-header">MOTOR Recommended Quantity</div>
          <div class="oil-card-body">{{ engineOilDetails?.recommend?.qty | number: '1.1-1' }} {{ engineOilDetails?.recommend?.unit }}</div>
        </div>

        <div class="oil-card-seprator">Viscosity recommendations</div>

        <div class="engine-oil-card-wrapper" *ngFor="let item of engineOilDetails?.recommendViscosity">
          <div class="oil-card-header">Temperature: {{ item?.temp }}</div>
          <div class="oil-card-body">{{ item?.value }}</div>
        </div>
      </div>
      <div class="col-9 engine-oil-right">
        <div class="engine-oil-content-wrapper">
          <div class="engine-oil-right-body">
            <div class="engine-oil-filter-wrapper">
              <div class="filter-icon">
                <i class="far fa-filter"></i>
              </div>
              <div class="row filter-field-container">
                <div class="col-4 filter-field">
                  <div class="filter-field-lable">Formulation</div>
                  <div class="filter-ddl">
                    <app-auto-complete
                      placeholder="Select formulation"
                      theme="border"
                      position="bottom"
                      field="name"
                      styleClassSelectedView="payment-method-dropdown"
                      scrollHeight="198px"
                      [fontSize]="13"
                      [suggestions]="formulationOptions"
                      [value]="recommend?.formulation"
                      [disabled]="isProcessing"
                      [listItemFontSize]="13"
                      [isDropdownIconVisible]="true"
                      (appSelect)="handleChange('formulation', $event)"
                    >
                      <ng-template let-item appTemplate="item">
                        <div class="tag-item flex-between-center">
                          <div class="tag-item-action flex-end-center">
                            <div>
                              {{ item?.name }}
                            </div>
                            <div *ngIf="engineOilDetails?.recommend?.formulation === item.name" class="tag-item-action flex-end-center">
                              <div class="ml-2 default-pill">Default</div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </app-auto-complete>
                  </div>
                </div>
                <div class="col-4 filter-field">
                  <div class="filter-field-lable">Viscosity</div>
                  <div class="filter-ddl">
                    <app-auto-complete
                      placeholder="Select viscosity"
                      theme="border"
                      position="bottom"
                      field="name"
                      styleClassSelectedView="payment-method-dropdown"
                      scrollHeight="198px"
                      [fontSize]="13"
                      [value]="recommend?.viscosity"
                      [disabled]="isProcessing"
                      [suggestions]="viscosityOptions"
                      [listItemFontSize]="13"
                      [isDropdownIconVisible]="true"
                      (appSelect)="handleChange('viscosity', $event)"
                    >
                      <ng-template let-item appTemplate="item">
                        <div class="tag-item flex-between-center">
                          <div class="tag-item-action flex-end-center">
                            <!-- <span>{{ item?.name }}</span> -->
                            <div>
                              {{ item?.name }}
                            </div>
                            <div *ngIf="engineOilDetails?.recommend?.viscosity === item.name" class="tag-item-action flex-end-center">
                              <div class="ml-2 default-pill">Default</div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </app-auto-complete>
                  </div>
                </div>
                <div class="col-4 filter-field">
                  <div class="filter-field-lable">Quantity:</div>
                  <div class="row">
                    <div class="col-6 pr-1">
                      <div class="filter-ddl">
                        <app-input
                          id="qty"
                          placeholder="4.4"
                          [allowDecimal]="true"
                          theme="border"
                          [selectTextOnFocus]="true"
                          [disabled]="isProcessing"
                          [floatingLabel]="false"
                          [maxLength]="4"
                          [value]="changeDecimal(recommend.qty)"
                          (appChange)="onQuantityChange($event)"
                        >
                        </app-input>
                      </div>
                    </div>
                    <div class="col-6 pl-0">
                      <div class="filter-ddl">
                        <app-auto-complete
                          placeholder="Litres"
                          theme="border"
                          [disabled]="isProcessing"
                          position="bottom"
                          field="name"
                          styleClassSelectedView="payment-method-dropdown"
                          scrollHeight="198px"
                          [fontSize]="13"
                          [suggestions]="measureOptions"
                          [value]="recommend?.unit"
                          [listItemFontSize]="13"
                          [isDropdownIconVisible]="true"
                          (appSelect)="handleChange('unit', $event)"
                        >
                        </app-auto-complete>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Content -->
          <div class="container-form">
            <div *ngIf="isProcessing" class="overlay-form flex-center-center w-100">
              <!-- Please wait fields are loading ...... -->
              <i class="fal fa-spinner rotate font-50"></i>
            </div>

            <div *ngFor="let item of listData; let i = index">
              <div class="engine-oil-row-wrapper" [ngClass]="{ 'border-bottom': listData?.length - 1 !== i }">
                <div class="content-form engine-oil-row-left">
                  <div class="engine-checkbox-wrapper">
                    <app-checkbox class="pl-1" inputId="inv-checkbox-{{ i }}" (appChange)="onSelectPartLookup(item, $event, true, i)" [fontSize]="11"> </app-checkbox>
                  </div>
                  <div *ngIf="currentLang === 'fr' && item?.itemInfo?.titleFR || item?.itemInfo?.title" class="engine-id pt-1">
                    {{ currentLang === 'fr' && item?.itemInfo?.titleFR ? item?.itemInfo?.titleFR : item?.itemInfo?.title }} :
                  </div>
                  <span class="pt-2 pl-hover-number partNumber ml-2" [pTooltip]="copiedIndex == i ? 'Copied!' : 'Copy'" (click)="copyText(item?.itemInfo?.code, i)" [ngClass]="copiedIndex == i ? 'copied-active' : ''">
                    <span class="font-14 font-gray-700"> {{ item?.itemInfo?.code }}</span>
                    <i *ngIf="copiedIndex == i" class="fas fa-copy copy-icon p-1"></i>
                    <i *ngIf="copiedIndex !== i" class="far fa-copy font-14 copy-icon p-1"></i>
                  </span>
                  
                </div>
                <div class="d-flex engine-oil-row-right gap-2">
                  <div *ngIf="item?.itemInfo?.stocked" class="inventory">
                    In Inventory: <b> {{ item?.itemInfo?.countAvailable | number: '1.1-1' || 0 }} {{ recommend?.unit }}</b>
                  </div>
                  <div class="cost-pill">
                    Cost: <b>{{ item?.itemInfo?.cost | currency: 'USD' || 0 }}</b>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="noRecordFound && !recommendResultsNotFound">
              <p class="pl-2 pt-2">No matching inventory items found. Please adjust your parameters or consider adding this item to your inventory.</p>
            </div>
            <div *ngIf="recommendResultsNotFound && noRecordFound">
              <p class="pl-2 pt-2">Other Formulation and Viscosity select from the dropdown at the top to populate fluid results.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="engine-oil-footer">
    <div class="ui-g-12 text-right dialog-footer">
      <button id="btn-cancel" class="btn btn-border pointer btn-submit mr-2" [disabled]="isProcessingAddingList" (click)="handleClose()">Cancel</button>
      <button id="btn-save" class="btn btn-primary btn-submit" [disabled]="isProcessingAddingList || disableInventoryOrder" (click)="addRepairOrder()">
        <span>Confirm</span>

        <i class="ml-2 fal fa-spinner rotate" *ngIf="isProcessingAddingList"></i>
      </button>
    </div>
  </div>
</div>
